import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { exposePixelDiagnostics, initMetaPixel } from "./utils/metaPixel";

// Meta Pixel base code — corre antes de montar React, en cada carga de la página.
initMetaPixel();
exposePixelDiagnostics();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-25" data-mp="2abfe7c0s20sh" />);
}